// 显式引入并触发 i18next 初始化副作用，确保在任何组件渲染前完成 init。
import '@/locales/i18n';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
